import React from "react";

/**
 * Kit button (§2.7). variant: primary | secondary | ghost | destructive.
 * `loading` disables the button and shows a spinner in place of the icon.
 */
function Button({
  variant = "secondary",
  size,
  icon,
  loading = false,
  disabled = false,
  type = "button",
  className = "",
  children,
  ...rest
}) {
  const classes = ["fk-btn", `fk-btn--${variant}`, size === "sm" ? "fk-btn--sm" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {loading ? <span className="fk-btn__spinner" /> : icon}
      {children}
    </button>
  );
}

export default Button;
